export default __webpack_public_path__ + "static/media/play-hover.c00d4d2a.svg";